<ion-header>
  <ion-toolbar>

    <ion-button fill="solid" slot="end" class="back" (click)="cancel()">
      <ion-icon slot="start" name="close-circle-outline"></ion-icon>
      {{ 'General.Cancel' | translate }}
    </ion-button>

    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
@if (item) {
  <ion-content>
    <ion-grid style="margin-bottom: 60px;">
      <ion-row>
        <ion-col style="display: flex;justify-content: center">
          <div style="margin: 5px">
            <div>
              {{ 'SpecialRequest.SpecialRequest' | translate }}
            </div>
          </div>
        </ion-col>
      </ion-row>
      @if (false) {
        <ion-row style="justify-content: center;">
          <ion-col style="display: flex;justify-content: center">
            @for (option of item.item.itemOptionCategories; track option; let i = $index) {
              <div class="circle done" style="margin: 5px">
                {{ i+1 }}
              </div>
            }
            <div class="circle active" style="margin: 5px">
              {{item.item.itemOptionCategories.length + 1}}
            </div>
          </ion-col>
        </ion-row>
      }
      <ion-row>
        <ion-col style="text-align: center; font-style: italic;">
          {{item.item.itemName.translations[translationService.getLanguage()]}}
        </ion-col>
      </ion-row>
      <ion-row>
        @if (item.item.description) {
          <ion-col [innerHTML]="item.item.description.translations[translationService.getLanguage()]" style="text-align: center; font-style: italic;">
          </ion-col >
        }
      </ion-row>
      @if (orderItem.itemDetailCombination) {
        <ion-row>
          @if (item.item.isRetailItem && orderItem.itemDetailCombination.size) {
            <ion-col  style="text-align: center; font-style: italic;">{{orderItem.itemDetailCombination.size.translations[translationService.getLanguage()]}}
            </ion-col >
          }
        </ion-row>
      }
      @if (orderItem.itemDetailCombination) {
        <ion-row>
          @if (item.item.isRetailItem && orderItem.itemDetailCombination.color) {
            <ion-col  style="text-align: center; font-style: italic;">{{orderItem.itemDetailCombination.color.translations[translationService.getLanguage()]}}</ion-col >
          }
        </ion-row>
      }
      @for (option of orderItem.options; track option) {
        <ion-row>
          @if (option.quantity > 0) {
            <ion-col style="text-align: center; font-style: italic; font-size:10px;">
              {{option.name.translations[translationService.getLanguage()]}}
            </ion-col>
          }
        </ion-row>
      }
      <br>
        <form [formGroup]="CustomerMessage">
          @if (!item.item.isRetailItem) {
            <ion-row style="text-align: center;">
              @if (!settingService.configuration.mergeAllergyNote) {
                <ion-col >
                  <ion-label>{{ 'SpecialRequest.Allergies' | translate }}</ion-label>
                </ion-col>
              }
              @if (settingService.configuration.mergeAllergyNote) {
                <ion-col >
                  <ion-label>{{ 'SpecialRequest.Merged' | translate }}</ion-label>
                </ion-col>
              }
              <!--<ion-col>
              <ion-row>
                <ion-input [(ngModel)]="orderItem.allergies" type="text"></ion-input>
              </ion-row>
            </ion-col>-->
          </ion-row>
        }
        @if (!item.item.isRetailItem) {
          <ion-row>
            <ion-col size="6" style="margin-left:auto; margin-right: auto;">
              <ion-input [(ngModel)]="orderItem.allergies" formControlName="allergies" type="text"></ion-input>
              <!--we'll setup input error information here-->
              <!--<span style="font-size: 9px;" *ngIf="formErrors.allergies">*{{ formErrors.allergies }}</span>-->
              @if (this.validators.getErrorMessage('allergies')) {
                <span style="font-size: 9px;">*{{ "ValidationErrorMessage." + this.validators.getErrorMessage('allergies') | translate }}</span>
              }
            </ion-col>
          </ion-row>
        }
        @if (!settingService.configuration.mergeAllergyNote) {
          <ion-row style="text-align: center;">
            <ion-col>
              <ion-label>{{ 'SpecialRequest.SpecialRequest' | translate }}</ion-label>
            </ion-col>
          </ion-row>
        }
        @if (!settingService.configuration.mergeAllergyNote) {
          <ion-row >
            <ion-col size="6" style="margin-left:auto;margin-right: auto;">
              <ion-textarea rows="1" [(ngModel)]="orderItem.note" formControlName="ordernote"></ion-textarea>
            </ion-col>
          </ion-row>
        }
      </form>
    </ion-grid>
    <div class="total-container">
      @if (settingService.configuration.uIoptions?.unDockTotalMenu) {
        <div class="Item-total-Box">
          <div class="Item-number-Container">
            <button (click)="changeItemNumber(-1)" class="Unstyled-Button">-</button>
            <p>{{numberOfItem}}</p>
            <button (click)="changeItemNumber(1)" class="Unstyled-Button">+</button>
          </div>
          @if (this.validators.formValidity()) {
            <button class="Item-number-Next" (click)="nextOption()">Add: {{total * numberOfItem | currency}}</button>
          }
          @if (!this.validators.formValidity()) {
            <button class="Item-number-Next btn_disabled">Add: {{total * numberOfItem | currency}}</button>
          }
        </div>
      }
      @if (!settingService.configuration.uIoptions?.unDockTotalMenu) {
        <ion-grid style="padding: 0;">
          <ion-row  style="padding: 0;">
            <ion-col style="background-color: white; display: flex; justify-content: flex-end; padding: 0;">
            </ion-col>
          </ion-row>
          <ion-row style="padding: 0;">
            <ion-col style="padding: 0;" size="4">
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-item class="total ion-text-center">
                      <ion-icon style="cursor: pointer;" (click)="goBack()" class="chevron-back" name="chevron-back-outline"></ion-icon>
                      <ion-label>
                        {{total | currency}}
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
            <ion-col>
              @if (this.validators.formValidity()) {
                <ion-item class="continue ion-text-center">
                  <ion-label style="text-align:right;">
                    <ion-button style="color:black;" (click)="nextOption()" fill="clear">{{ 'General.Next' | translate }}</ion-button>
                  </ion-label>
                  <ion-icon name="chevron-forward-outline" item-right></ion-icon>
                </ion-item>
              }
              @if (!this.validators.formValidity()) {
                <ion-item class="continue_btn_disabled ion-text-center">
                  <ion-label style="text-align:right;">
                    <ion-button style="color:black;" fill="clear">{{ 'General.Next' | translate }}</ion-button>
                  </ion-label>
                  <ion-icon name="chevron-forward-outline" item-right></ion-icon>
                </ion-item>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
      }
    </div>
  </ion-content>
}